import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/index'

import tagsview from './tagsview'
import websocketInfo from './websocketInfo'
import { postUserInfo, getRoutesData } from "@/network/login.js";
import { Notification } from 'element-ui';



Vue.use(Vuex);



const store = new Vuex.Store({
    namespaced: true,
    state: {
        URL: process.env.API_ROOT,
        navShow: false,
        userInfo: '',
        routers: [],
        userlist: '',
        showDialog: false, //修改密码弹框
    },
    mutations: {
        userInfo(state, info) {
            state.userInfo = info;
        },
        routers(state, info) {
            state.routers = info;
        },
        // token过期
        tokenInvalid() {
            // 返回 401 清除token信息并跳转到登录页面
            localStorage.removeItem("token");
            localStorage.removeItem("routes");

            setTimeout(() => {
                router.replace({
                    path: '/login'
                })
                location.reload();
            }, 1500);
        },
        infoInvalid() {
            Notification.error({ message: '登陆过期，请重新登陆。' });
        }
    },
    actions: {

        // 登陆成功 & 刷新页面的回调
        requestUserInfo({ commit, state }, isGoHome) {
            if (isGoHome) router.push({ path: '/home' })
            let token = localStorage.getItem("token");
            if (token) {
                return postUserInfo().then((res) => {
                    commit('userInfo', res); //保存个人信息

                    commit('getSysconfByName', res)
                });
            }
        },
        routers({ commit, state }) {
            let routerJurisdiction = JSON.parse(localStorage.getItem("routes"));
            if (!routerJurisdiction) {
                if (!localStorage.getItem("token")) return false;
                return getRoutesData(state.userInfo.roleLevel)
            } else {
                return new Promise(resolve => {
                    resolve(routerJurisdiction);
                })
            }
        }
    },
    getters: {
        imgLink() {
            let imgLink = process.env.NODE_ENV === 'production' ? process.env.BASE_API : process.env.API_ROOT;
            return imgLink.slice(0, imgLink.lastIndexOf(':'));
        }
    },

    modules: {
        tagsview,
        websocketInfo
    },

})



export default store;


// WEBPACK FOOTER //
// ./src/store/store.js